export default __webpack_public_path__ + "static/media/our-events-hero.750e4fda.png";